var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.thread && _vm.thread.id
      ? _c("div", [
          _c("div", { staticClass: "drawer-heading" }, [
            _c("h3", [_vm._v(_vm._s(this.thread.booking.name))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "drawer-body" }, [
            _c(
              "div",
              { staticClass: "sidebar" },
              [
                _vm.$userIsAdmin && this.thread.active
                  ? _c(
                      "button",
                      {
                        staticClass: "drawer-button",
                        on: { click: _vm.handleCloseThreadCallback },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-envelope fa-fw",
                          attrs: { title: "Close Thread" },
                        }),
                        _vm._v("\n          Shutdown Thread\n        "),
                      ]
                    )
                  : _vm.$userIsAdmin
                  ? _c(
                      "button",
                      {
                        staticClass: "drawer-button",
                        on: { click: _vm.handleReopenThreadCallback },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-envelope-open fa-fw",
                          attrs: { title: "Reopen Thread" },
                        }),
                        _vm._v("\n          Reopen Thread\n        "),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin
                  ? _c("div", [
                      !_vm.thread.pinned
                        ? _c(
                            "button",
                            {
                              staticClass: "drawer-button",
                              on: { click: _vm.handlePinThreadCallback },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-thumb-tack fa-fw",
                              }),
                              _vm._v("\n              Pin\n          "),
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "drawer-button",
                              on: { click: _vm.handleUnpinThreadCallback },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-thumb-tack fa-fw",
                              }),
                              _vm._v("\n              Unpin\n          "),
                            ]
                          ),
                      _vm._v(" "),
                      _c("br"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._l(this.thread.participants, function (participant) {
                  return _c("div", { key: participant.id }, [
                    !_vm.$checkUserIsAdmin(participant)
                      ? _c("p", [
                          _c("img", {
                            attrs: { src: participant.avatar, alt: "" },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(participant.name) +
                              " (" +
                              _vm._s(_vm.$t(participant.role)) +
                              ")\n          "
                          ),
                        ])
                      : _vm._e(),
                  ])
                }),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: _vm.$vlastMode
                        ? "/img/vlast-avatar-128.png"
                        : "/img/pickstar-avatar-128.png",
                      alt: "",
                    },
                  }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.clientName) + " Admin\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.threadFiles
                  ? _c(
                      "div",
                      [
                        _c("h5", [
                          _c("strong", [_vm._v("BOOKING FILES")]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-xs btn-primary rounded-button",
                              attrs: { type: "submit" },
                              on: { click: _vm.handleGetFileInputSidebar },
                            },
                            [
                              _vm._v(
                                "\n              Upload Files\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "fileInputSidebar",
                            staticStyle: { display: "none" },
                            attrs: { type: "file", multiple: "" },
                            on: { change: this.handleAddBookingFiles },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.threadFiles.length
                          ? _c(
                              "ul",
                              { staticStyle: { padding: "0" } },
                              [
                                _vm._l(_vm.threadFiles, function (file) {
                                  return _c("booking-file-list-item", {
                                    key: file.id,
                                    attrs: {
                                      file: file,
                                      booking: _vm.thread.booking,
                                    },
                                  })
                                }),
                                _vm._v(" "),
                                _vm.loading
                                  ? _c("pickstar-loading", {
                                      staticClass: "m-t-sm",
                                    })
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm.loading
                          ? _c("pickstar-loading", { staticClass: "m-t-sm" })
                          : _vm.threadFiles
                          ? _c("no-results", [
                              _vm._v(
                                "\n            There are currently no files.\n          "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm.$userIsAdmin
                  ? _c("div", { staticClass: "row" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-8" }, [
                        _c("p", [_vm._v(" " + _vm._s(this.thread.booking.id))]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-4" }, [
                    _vm.$costReferences
                      ? _c("p", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm._f("sentenceCase")(_vm.$t("budget")))
                            ),
                          ]),
                        ])
                      : _c("p", [_c("strong", [_vm._v("Value")])]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-8" }, [
                    _vm.$userIsTalent || _vm.$userIsManager
                      ? _c("p", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("nullable")(
                                  _vm._f("currency")(
                                    this.thread.booking
                                      .budget_per_star_as_user_rate,
                                    this.thread.booking.currency
                                  )
                                )
                              ) +
                              "\n              "
                          ),
                          _vm.$userIsManager
                            ? _c("span", [
                                _vm._v(
                                  "\n              /" +
                                    _vm._s(_vm.$starLabel) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _c("p", [
                          _vm.$costReferences
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("currency")(
                                        this.thread.booking.budget_per_star,
                                        this.thread.booking.currency
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$userIsAdmin &&
                          this.thread.booking.currency !== "points"
                            ? _c("span", [
                                _vm._v(
                                  "\n                (" +
                                    _vm._s(
                                      _vm._f("currency")(
                                        this.thread.booking
                                          .budget_per_star_as_user_rate,
                                        this.thread.booking.currency
                                      )
                                    ) +
                                    ")\n              "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.budgetPostText) +
                                "\n              "
                            ),
                          ]),
                        ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-8" }, [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "overflow-y": "hidden",
                          display: "-webkit-box",
                          "max-height": "10vh",
                          "-webkit-line-clamp": "4",
                          "-webkit-box-orient": "vertical",
                          "text-overflow": "ellipsis",
                        },
                      },
                      [
                        _c("span", { attrs: { id: "description" } }, [
                          _vm._v(_vm._s(this.thread.booking.description)),
                        ]),
                        _vm._v(" "),
                        _c("tooltip", {
                          attrs: {
                            target: "#description",
                            text: this.thread.booking.description,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-8" }, [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "overflow-y": "hidden",
                          display: "-webkit-box",
                          "max-height": "10vh",
                          "-webkit-line-clamp": "4",
                          "-webkit-box-orient": "vertical",
                          "text-overflow": "ellipsis",
                        },
                      },
                      [
                        _c("span", { attrs: { id: "requirements" } }, [
                          _vm._v(_vm._s(this.thread.booking.requirements)),
                        ]),
                        _vm._v(" "),
                        _c("tooltip", {
                          attrs: {
                            target: "#requirements",
                            text: this.thread.booking.requirements,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.thread.booking.address
                  ? _c("div", { staticClass: "row" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-8" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm._f("nullable")(_vm.thread.booking.address)
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.thread.booking.date
                  ? _c("div", { staticClass: "row" }, [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-8" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(
                                this.thread.booking.date,
                                _vm.$user.date_format_preference
                              )
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-8" }, [
                    this.thread.booking.status === "scheduled"
                      ? _c("p", [
                          _c(
                            "span",
                            { staticClass: "messaging-tag mt-orange" },
                            [
                              _vm._v(_vm._s(this.thread.booking.status) + " "),
                              _c("i", { staticClass: "fa fa-check" }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    this.thread.booking.status === "booked"
                      ? _c("p", [
                          _c(
                            "span",
                            { staticClass: "messaging-tag mt-green" },
                            [
                              _vm._v(_vm._s(this.thread.booking.status) + " "),
                              _c("i", { staticClass: "fa fa-check" }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    this.thread.booking.status === "completed"
                      ? _c("p", [
                          _c(
                            "span",
                            { staticClass: "messaging-tag mt-green" },
                            [
                              _vm._v(_vm._s(this.thread.booking.status) + " "),
                              _c("i", { staticClass: "fa fa-check" }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    this.thread.booking.status === "cancelled"
                      ? _c("p", [
                          _c("span", { staticClass: "messaging-tag mt-red" }, [
                            _vm._v(_vm._s(this.thread.booking.status) + " "),
                            _c("i", { staticClass: "fa fa-cross" }),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                this.$route !== "bookings.show"
                  ? _c(
                      "router-link",
                      {
                        staticClass: "messaging-flex-box",
                        attrs: {
                          to: {
                            name: "bookings.show",
                            params: { id: this.thread.booking.id },
                          },
                          href: "#drawer-messages-chat",
                          "data-toggle": "drawer",
                          "aria-foldedopen": "true",
                          "aria-controls": "drawer-messages-chat",
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "btn btn-primary btn-sm rounded-button",
                            on: { click: _vm.viewBooking },
                          },
                          [_vm._v("View Booking")]
                        ),
                        _c("br"),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                this.thread.booking.payments &&
                this.thread.booking.payments.length > 0
                  ? _c("div", [
                      _vm.$userIsAdmin || _vm.$userIsClient
                        ? _c("h5", [_c("strong", [_vm._v("PAYMENT DETAILS")])])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userCanSeePaymentStatus
                        ? _c("div", { staticClass: "row" }, [
                            _vm._m(8),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-xs-8" }, [
                              _c("p", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "messaging-tag",
                                    class: _vm.paymentClass(
                                      this.thread.booking.payments[0].status
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        this.thread.booking.payments[0].status
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-4" }, [
                          this.thread.booking.payments[0].paid_date &&
                          (_vm.$userIsAdmin || _vm.$userIsClient)
                            ? _c("p", [_c("strong", [_vm._v("Paid Date ")])])
                            : _vm.$userIsAdmin || _vm.$userIsClient
                            ? _c("p", [_c("strong", [_vm._v("Due Date  ")])])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-8" }, [
                          this.thread.booking.payments[0].paid_date &&
                          (_vm.$userIsAdmin || _vm.$userIsClient)
                            ? _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("date")(
                                        this.thread.booking.payments[0]
                                          .paid_date,
                                        _vm.$user.date_format_preference
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ])
                            : _vm.$userIsAdmin || _vm.$userIsClient
                            ? _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("date")(
                                        this.thread.booking.payments[0]
                                          .due_date,
                                        _vm.$user.date_format_preference
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.userCanSeePaymentStatus
                        ? _c("div", { staticClass: "row" }, [
                            _vm._m(9),
                            _vm._v(" "),
                            this.thread.booking.payments.length > 1
                              ? _c("div", { staticClass: "col-xs-8" }, [
                                  _c("p", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "messaging-tag",
                                        class: _vm.paymentClass(
                                          this.thread.booking.payments[1].status
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            this.thread.booking.payments[1]
                                              .status
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      this.thread.booking.payments.length > 1
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-xs-4" }, [
                              this.thread.booking.payments[1].paid_date &&
                              (_vm.$userIsAdmin || _vm.$userIsClient)
                                ? _c("p", [
                                    _c("strong", [_vm._v("Paid Date ")]),
                                  ])
                                : _vm.$userIsAdmin || _vm.$userIsClient
                                ? _c("p", [_c("strong", [_vm._v("Due Date ")])])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-xs-8" }, [
                              this.thread.booking.payments[1].paid_date &&
                              (_vm.$userIsAdmin || _vm.$userIsClient)
                                ? _c("p", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("date")(
                                            this.thread.booking.payments[1]
                                              .paid_date,
                                            _vm.$user.date_format_preference
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm.$userIsAdmin || _vm.$userIsClient
                                ? _c("p", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("date")(
                                            this.thread.booking.payments[1]
                                              .due_date,
                                            _vm.$user.date_format_preference
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ])
      : _c("div", [_c("pickstar-loading", { staticClass: "m-t-lg" })], 1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [_c("strong", [_vm._v("PARTICIPANTS")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [_c("strong", [_vm._v("BOOKING DETAILS")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("p", [_c("strong", [_vm._v("Booking ID")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("p", [_c("strong", [_vm._v("Request Details")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("p", [_c("strong", [_vm._v("Requirements")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("p", [_c("strong", [_vm._v("Location")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("p", [_c("strong", [_vm._v("Event Date")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("p", [_c("strong", [_vm._v("Status")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("p", [_c("strong", [_vm._v("Deposit")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("p", [_c("strong", [_vm._v("Final")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }